// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__166q3","emails":"CreateEditClinics_emails__3C1I9","emailTagLabel":"CreateEditClinics_emailTagLabel__3kKsr"};